import { User } from '@shared/models/user.model'
import { Device } from '@shared/models/device.model'
import { Client } from '@shared/models/client.model'
import { Vehicle } from '@shared/models/vehicle.model'
import { Geofence } from '@app/modules/client/shared/models/geofence.model'

export type SearchResult = SearchResultGroup[]

export type SearchResultGroup =
  | SearchResultClientRow
  | SearchResultUserRow
  | SearchResultDeviceRow
  | SearchResultVehicleRow
  | SearchResultGeofenceRow

export interface SearchResultClientRow {
  type: SearchResultType.Client
  items: Client[]
}

export interface SearchResultUserRow {
  type: SearchResultType.User
  items: User[]
}

export interface SearchResultDeviceRow {
  type: SearchResultType.Device
  items: Device[]
}

export interface SearchResultVehicleRow {
  type: SearchResultType.Vehicle
  items: Vehicle[]
}

export interface SearchResultGeofenceRow {
  type: SearchResultType.Geofence
  items: Geofence[]
}

export enum SearchResultType {
  Client = 'client',
  User = 'user',
  Device = 'device',
  Vehicle = 'vehicle',
  Geofence = 'area',
}
